import { date } from "quasar";
import { numberFormat } from "src/assets/scripts/utilities/helpers";

const statusMapping = {
  partially_paid: "Partially Paid",
  paid: "Paid",
  unpaid: "Unpaid",
};

export const usePaymentStatus = () => {
  const getStatusLabel = (row) => {
    const { payment_summary, due_date, status_cd, status } = row;

    if (!payment_summary) return status;

    if (status_cd === "cancelled") return "Cancelled";

    const dueDate = date.extractDate(due_date);
    const currentDate = new Date();
    const daysDifference = date.getDateDiff(currentDate, dueDate, "days");

    const isOverdue =
      daysDifference > 0 &&
      (payment_summary.total_paid_amount === 0 ||
        payment_summary.status_cd === "partially_paid");

    if (isOverdue) return "Overdue";

    if (payment_summary.status_cd !== "unpaid") {
      return statusMapping[payment_summary.status_cd] || status;
    }

    return status;
  };

  const getDueDateMessage = (row) => {
    const { payment_summary, due_date, status_cd } = row;

    if (payment_summary?.status_cd === "paid" || status_cd === "cancelled") {
      return "";
    }

    const currentDate = new Date();
    const dueDateObj = new Date(due_date);

    currentDate.setHours(0, 0, 0, 0);

    dueDateObj.setHours(0, 0, 0, 0);

    const timeDifference = currentDate.getTime() - dueDateObj.getTime();
    const daysDifference = Math.round(timeDifference / (1000 * 60 * 60 * 24));

    if (daysDifference === 0) {
      return "Due Today";
    } else if (daysDifference > 0) {
      return `By ${daysDifference} ${daysDifference === 1 ? "day" : "days"}`;
    } else {
      const absDays = Math.abs(daysDifference);

      return `Due in ${absDays} ${absDays === 1 ? "day" : "days"}`;
    }
  };

  const getDueBalance = (row) => {
    const { payment_summary, status_cd } = row;
    let number = 0;

    if (status_cd !== "paid") {
      number = payment_summary?.balance_due || 0;
    }

    return numberFormat({
      number,
      style: "currency",
    });
  };

  return {
    getStatusLabel,
    getDueDateMessage,
    getDueBalance,
  };
};
